// extracted by mini-css-extract-plugin
export var emailBlockLink = "_j3-0";